import React from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, Box, Button } from '@mui/material';

export default function ErrorPhase({ message, onReset }) {
  const { t } = useTranslation('inventory');

  return (
    <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 2, pt: 4 }}>
      <Alert severity="error" sx={{ fontSize: '1rem' }}>
        {message}
      </Alert>
      <Button variant="outlined" size="large" onClick={onReset} fullWidth sx={{ minHeight: 52, fontSize: '1.05rem' }}>
        {t('inventory:scanner.scan_again')}
      </Button>
    </Box>
  );
}
